<template>
    <div class="user-card">
        <div class="user-info">
            <img v-if="state.userInfo?.icon" :src="state.userInfo?.icon" alt="" class="avatar" />
            <img v-else src="@/assets/img/user-photo.png" alt="" class="avatar" />
            <div class="detail">
                <p class="name">{{ state.userInfo?.name }}</p>
                <p class="stages">
                    <span v-if="state.userInfo?.standardSchoolName">{{
                        state.userInfo?.standardSchoolName
                    }}</span>
                    <span class="no-school" v-else>暂无学校（单位）信息</span>
                    <!-- <span class="change-btn">
                        <img src="@/assets/img/user-center/change-icon.png" alt="" class="icon">切换
                    </span> -->
                </p>
                <p class="desc" v-if="state.userInfo?.teacherStageRefSubjects?.length">
                    <Ellipsis
                        placement="bottom"
                        effect="light"
                        :rows="2"
                        :content="handleStageSubject(state.userInfo?.teacherStageRefSubjects)"
                    />
                </p>
                <p class="desc" v-else>暂无学段学科</p>
            </div>
        </div>
        <div class="follow">
            <template v-if="state.userInfo?.isUserSelfPage">
                <p class="count">
                    <span>我的粉丝</span>
                    <span class="num" @click="goPage('fans')">{{ state.userInfo?.fansNum }}</span>
                </p>
                <p class="count like">
                    <span>我的关注</span>
                    <span class="num" @click="goPage('followed')">{{
                        state.userInfo?.followNum
                    }}</span>
                </p>
                <div>
                    <span @click="edit" class="btn edit-info">编辑个人信息</span>
                    <span v-if="showSiteList" @click="selectAddress" class="btn select-info">切换站点</span>
                </div>
            </template>
            <p class="btns" v-else>
                <span
                    v-if="state.isFollow == 0 || state.isFollow == 3"
                    @click="follow(true)"
                    class="btn follow-info"
                    >+关注</span
                >
                <span
                    v-if="state.isFollow == 1 || state.isFollow == 2"
                    @click="follow(false)"
                    class="btn follow-info followed"
                >
                    <i
                        ><img
                            class="follow-icon"
                            src="@/assets/img/user-center/followed-icon.png"
                            alt=""
                        />
                        已关注
                    </i>
                    <i>取消关注</i>
                </span>
            </p>
        </div>
        <el-dialog
            title="站点选择"
            :model-value="address.showRedirectModal"
            @close="address.showRedirectModal = false"
            width="30%"
            class="address_select"
            :append-to-body="true"
        >
            <el-radio-group
                v-model="address.redirectUrl"
                v-for="(item, index) in personalInstitutions"
                :key="`${index}_redirect_radio`"
                class="user_card_group"
            >
                <el-radio class="user_card_radio" :label="item.address">{{ item.institutionName }}</el-radio>
            </el-radio-group>
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="goRedirectUrl">确 定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { computed, reactive, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { pageJump } from '@/global/location-transfer';
import message from '@/components/message/message.js';
import { handleStageSubject } from '@/lib/biz-tools';
import Ellipsis from '@/components/ellipsis.vue';
import {cloneDeep} from 'lodash';

const store = useStore();
const route = useRoute();
const address = reactive({
    showRedirectModal: false,
    redirectUrl: '',
});
const state = reactive({
    isFollow: 0, // 是否关注
    userInfo: {}, // 用户信息，本人或者他人
});

// 是否展示用户站点信息, 切换站点
const showSiteList = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let list = pagePermission.switchOtherInst?.moduleRuleList || [];
    let res = list.find(item => !!item.checked) || {};
    return res.ruleKey === 'yes';
})
// 获取机构id
const getInstitutionId = computed(() => {
    const institutionByBrand = store.state?.common?.institutionByBrand || {};
    return institutionByBrand?.id;
})

// 站点列表
const personalInstitutions = computed(() => {
    const list = store.state.user?.personalInstitutions || [];
    return list
})

// 判断是否是他人视角
const isOtherUser = computed(() => {
    return route.query?.uId;
});

// 获取用户信息 当前用户不传参，他人主页传uid
function getUserInfo(userId) {
    let rId = isOtherUser.value ? route.query.uId : userId;
    G_transmit('getCenterUserInfo', {
        data: {
            currentTeacherId: rId,
        },
    }).then(res => {
        let data = res.data || {};
        data.teacherStageRefSubjects = [];
        state.userInfo = data || {};
        getMemberByUserId(data.userId);
        if (userId && userId === res.data.userId) {
            state.userInfo.isUserSelfPage = true;
        }
        !state.userInfo.isUserSelfPage && getIsFollow();
    });
}

// 登录成功后重定向
function goRedirectUrl() {
    address.showRedirectModal = false;
    location.href = `https://${address.redirectUrl}`;
}

// 获取站点的用户信息-学段学科
function getMemberByUserId(userId) {
    G_transmit('getMemberInfoByUserId', {
        queries: {
            userId,
        },
    }).then(res => {
        state.userInfo.teacherStageRefSubjects = res.data?.stageSubjectGradeList || [];
    });
}

// 跳转编辑用户信息
function edit() {
    pageJump({
        name: 'accountInfo',
        query: {
            tab: 'info',
        },
    });
}

async function selectAddress() {
    const curInstitutionInfo = personalInstitutions.value.find(item => item?.institutionId == getInstitutionId.value);
    if (curInstitutionInfo) {
        address.redirectUrl = curInstitutionInfo?.address;
    }
    address.showRedirectModal = true;
}

function goPage(type) {
    pageJump({
        name: 'followList',
        query: {
            tab: type,
        },
    });
}

// 双方关注关系
const getIsFollow = function () {
    G_transmit('followRelation', {
        name: 'followRelation',
        queries: {
            herId: state.userInfo.userId,
        },
    }).then(res => {
        state.isFollow = res.data;
    });
};

// 关注取消关注
const follow = function (type) {
    G_transmit('followOperate', {
        name: 'followOperate',
        data: {
            followToId: state.userInfo.userId,
            operateType: type ? 1 : 0,
            followToType: 'user',
        },
    }).then(res => {
        state.isFollow = res.data;
        message({ text: `${res.data == 0 ? '取消关注成功' : '关注成功'}`, type: 'success' });
    });
};

// 监听个人信息变化
watch(
    () => store.state.currentUser,
    val => {
        if (!isOtherUser.value) {
            getUserInfo();
        } else {
            if (val.userId && route.query.uId && route.query.uId === val.userId) {
                state.userInfo.isUserSelfPage = true;
            }
        }
    },
    { deep: true, immediate: true },
);

// 监听第三方信息
watch(
    () => isOtherUser.value,
    val => {
        if (val) {
            getUserInfo();
        } else {
            getUserInfo();
        }
    },
    { deep: true, immediate: true },
);

onMounted(() => {});
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.user_card_group{
    display: block !important;
}
.user-card {
    width: 100%;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    padding: 30px;
    box-sizing: border-box;
    background: url('~@/assets/img/user-center/user-card-bg.png') 0 0 no-repeat;
    background-size: 100% 100%;
    .user-info {
        display: inline-flex;
        align-items: center;
        .avatar {
            width: 130px;
            height: 130px;
            border-radius: 50%;
            margin-right: 20px;
        }
        .detail {
            font-size: 16px;
            font-weight: bold;
            color: #222222;
            max-width: 600px;
            line-height: 22px;
            .stages {
                font-size: 14px;
                color: #222222;
                line-height: 18px;
                margin: 10px 0 17px 0;
                font-weight: normal;
                .no-school {
                    color: #999999;
                }
                .change-btn {
                    color: #0084f6;
                    cursor: pointer;
                    img {
                        width: 14px;
                        height: 14px;
                        margin-right: 4px;
                        margin-left: 10px;
                    }
                }
            }
            .desc {
                font-size: 14px;
                color: #666666;
                line-height: 21px;
                max-width: 500px;
                font-weight: 400;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                -webkit-line-clamp: 2;
            }
        }
    }
    .follow {
        display: flex;
        align-items: center;
        .count {
            display: inline-flex;
            flex-direction: column;
            align-items: flex-start;
            font-size: 12px;
            color: #666666;
            line-height: 12px;
            position: relative;
            padding: 0 30px;
            .num {
                font-size: 30px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #222222;
                line-height: 30px;
                margin-top: 10px;
                cursor: pointer;
            }
            &:first-child::after {
                content: '';
                display: inline-block;
                width: 1px;
                height: 30px;
                background-color: #e0e2e4;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translate(0, -50%);
            }
            // &:last-child{
            //     padding-right: 0;
            // }
        }
        .like {
            padding-right: 40px;
        }
        .btn {
            padding: 7px 16px;
            border-radius: 16px;
            font-size: 14px;
            cursor: pointer;
            font-weight: normal;
        }
        .edit-info {
            border: 1px solid #0084f6;
            color: #0084f6;
            display: block;
            // margin-left: 40px;
        }
        .select-info {
            border: 1px solid #222222;
            color: #222222;
            margin-top: 8px;
            text-align: center;
            display: block;
            // margin-left: 40px;
        }
        .btns {
            margin-left: 40px;
            .follow-info {
                background: #0084f6;
                color: #ffffff;
            }
            .followed {
                background: #ffffff;
                color: #666666;
                display: inline-flex;
                align-items: center;
                i {
                    font-style: initial;
                }
                & i:last-child {
                    display: none;
                }
                &:hover {
                    & i:first-child {
                        display: none;
                    }
                    & i:last-child {
                        display: initial;
                        color: #0084f6;
                    }
                }
            }
            .follow-icon {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }
        }
    }
}
</style>
